import script from "./CancelledSessions.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelledSessions.vue?vue&type=script&setup=true&lang=js"

import "./CancelledSessions.vue?vue&type=style&index=0&id=566bedee&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566bedee"]])

export default __exports__